import React, { Component } from "react"
import {
  Table,
  Icon,
  message,
  Input,
  Modal,
  Row,
  Menu,
  Dropdown
} from "antd"
import "./Index.scss"
import config from "app/config"
import { observer, inject } from "mobx-react"
import editIcon from "app/styles/images/sp/edit.svg"
import titleIcon from "app/styles/images/sp/title.svg"
import closeIcon from "app/styles/images/sp/close.svg"
import recoveryIcon from "app/styles/images/sp/recovery.svg"
import deleteAbleIcon from "app/styles/images/sp/delete.svg"
import deleteDisableIcon from "app/styles/images/sp/delete-disable.svg"
import deleteWarningIcon from "app/styles/images/sp/delete-warning.svg"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"
import MaterialModal from "app/components/normal/MaterialModal"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import ShareModal from "app/components/normal/ShareModal"
import cx from "classnames"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"
import { PREPARE_RUN, RUNNING, SUCCESS, FAIL } from 'app/utils/const'
import DownloadingModal from '../../DownloadingModal'
import { withRouter } from 'react-router-dom'
import DataOriginText from 'app/components/normal/DataOriginText'

@inject("entrance", "auth") @observer
class ReportCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      shareModalShowed: false,
      detailModal: false,
      downLoadModal: false,
      showEditModal: false,
      dataIndex: 0,
      options: [],
      editGroupName: "",
      showDeleteModal: false,
      showDeleteGroupModal: false,
      dataSingle: {},
      groupNameHistory: [],
      versionChoiceShowed: false,
      cancelShareModal: false,
      downloadText: ''
    }
  }

  openDetail(record) {
    let { getDetailData, clearDetailData } = this.props.store
    let { data = {}, history, match } = this.props

    const index = data.reportList.findIndex(report =>
      report.reportId === record.reportId
    )

    clearDetailData()

    this.setState({
      dataIndex: index
    })

    let reportId = data.reportList[index].reportId
    getDetailData(reportId)
      .then(res => {
        record.isRead = true
      })
    history.push(`${match.url}/${data.groupName}/${reportId}`)
  }

  showShareModal = () => {
    this.setState({
      shareModalShowed: true
    })
  }

  showModal = (field) => {
    this.setState({
      [field]: true
    })
  }

  showEditModal = () => {
    const { data, store: { getGroupListById } } = this.props

    this.setState({
      showEditModal: true,
      editGroupName: data.groupName
    })
    getGroupListById(data.groupId, "deleted")
  }

  closeModal = (modal, cb = () => { }) => {
    this.setState({
      [modal]: false
    }, cb)
  }

  renderGroupButtons = () => {
    let { data = {} } = this.props
    if (data.mine) {
      return (
        <Row type="flex" justify="center" className="info-buttons">
          <a>
            <Row onClick={this.showEditModal} type="flex" justify="center" align="middle" gutter={3}>
              <img className="edit-btn" src={editIcon} alt="编辑" />
              <div>编辑</div>
            </Row>
          </a>
          <a onClick={this.downloadCsvStep}><Icon type="download" />组数据</a>
          <a onClick={this.showShareModal}><Icon type="upload" />共享</a>
        </Row>
      )
    } else {
      return (
        <Row type='flex' align='middle' justify='center' className='share-info'>
          <Icon type="share-alt" /> 数据来源于：<DataOriginText className='ellipsis'>{data.ownerName}</DataOriginText>
          <Dropdown
            overlay={(
              <Menu>
                <Menu.Item>
                  <a onClick={this.export}>
                    <Icon type="download" />导出
                  </a>
                </Menu.Item>
                <Menu.Item>
                  <a onClick={() => this.showModal('cancelShareModal')}>
                    <Icon type="close-circle-o" theme="outlined" />
                    取消共享
                  </a>
                </Menu.Item>
              </Menu>
            )}
            placement="bottomCenter"
          >
            <a className='more'>
              <Icon
                style={{ fontSize: 16, fontWeight: 'bold' }}
                type='ellipsis'
              />
            </a>
          </Dropdown>
        </Row>
      )
    }
  }

  copyText = (content) => {
    let targetId = "_hiddenCopyText_"
    let currentFocus = document.activeElement
    let target = document.getElementById(targetId)
    currentFocus.focus()

    // 如果不是，则使用节点的textContent
    if (!target) {
      //如果不存在，则创建一个
      target = document.createElement("textarea")
      target.style.position = "absolute"
      target.style.left = "-9999px"
      target.style.top = "0"
      target.id = targetId
      document.body.appendChild(target)
    }
    target.textContent = content
    // 聚焦目标节点，选中它的内容
    target.focus()
    target.setSelectionRange(0, target.value.length)

    // 进行复制操作
    try {
      document.execCommand("copy")
      message.success("复制链接成功")
    } catch (e) {
      message.error("复制链接失败")
    }

    // 不再聚焦
    if (currentFocus && typeof currentFocus.focus === "function") {
      currentFocus.focus()
    }

    // 清空临时数据
    target.textContent = ""
  }

  shareGroup = (username, clearUsername) => {
    let { shareGroup, shareList } = this.props.store
    let groupId = this.props.data.groupId

    shareGroup(groupId, username)
      .then(res => {
        clearUsername()
        shareList.unshift(res)
        message.success("分享成功")
      }, err => {
        message.error(err.message)
      })
  }

  downloadCsvStep = (templateId) => {
    const { downloadCsvStep } = this.props.store
    const { groupId } = this.props.data

    this.setState({
      downLoadModal: true,
    })
    downloadCsvStep(groupId)
      .then(res => {
        this.setState({
          downLoadModal: false,
        })
        if (document.getElementById("download-a-tag")) document.getElementById("download-a-tag").outerHTML = ""
        let a = document.createElement("iframe")
        a.setAttribute("src", res.url)
        a.setAttribute("id", "download-a-tag")
        a.setAttribute("style", "display:none;")
        document.body.appendChild(a)
      }, err => {
        message.error("下载失败，请您重试！")
        this.setState({
          downLoadModal: false,
        })
      })
  }

  download = () => {
    const {
      data = {},
      entrance: { templates },
      store: { getVersions, setVersions, setVersionType }
    } = this.props
    const downLoadTemplate = templates.find(
      (item) => data.appGroupName === item.appGroupName && item.type === "group" && item.format === "pdf"
    )

    getVersions(data.groupId)
      .then(
        res => {
          if (res.length > 1) {
            setVersionType('download')
            setVersions(res)
            this.showModal('versionChoiceShowed')
          } else {
            this.downloadStep1(downLoadTemplate.id, res[0].id)
          }
        },
        err => {
          message.error(err.message)
        }
      )
  }

  export = () => {
    let { downloadCsvStep } = this.props.store
    const { groupId } = this.props.data

    this.setState({
      downLoadModal: true,
    })
    downloadCsvStep(groupId)
      .then(res => {
        this.setState({
          downLoadModal: false,
        })
        if (document.getElementById("download-a-tag")) document.getElementById("download-a-tag").outerHTML = ""
        let a = document.createElement("iframe")
        a.setAttribute("src", res.url)
        a.setAttribute("id", "download-a-tag")
        a.setAttribute("style", "display:none;")
        document.body.appendChild(a)
      }, err => {
        message.error("下载失败，请您重试！")
        this.setState({
          downLoadModal: false,
        })
      })
  }

  goViewPage = (data, groupDataTeamplateId, versionId) => {
    let tmp = window.open('_blank')
    tmp.location = config.backend + '/pgs/reports/preview/' +
      data.groupId + '/group?templateId=' + groupDataTeamplateId + '&versionId=' + versionId
  }

  handleDifferPreview = (data, groupDataTemplateId, versionId) => {
    const { userInfo } = this.props.auth
    const { store: { getGroupsTemp } } = this.props
    const NORTH_WARZONE_HOSPITAL = '954'

    if (userInfo.orgId === NORTH_WARZONE_HOSPITAL) {
      getGroupsTemp(data.groupId)
        .then(
          res => {
            this.goViewPage(data, res.id, versionId)
          },
          err => {
            message.error(err.message)
          }
        )
    } else {
      this.goViewPage(data, groupDataTemplateId, versionId)
    }
  }

  preview = () => {
    const {
      data = {},
      entrance: { templates },
      store: { getVersions, setVersions, setVersionType }
    } = this.props
    const groupDataTemplate = templates.find(
      (item) => data.appGroupName === item.appGroupName && item.type === "group" && item.format === "html"
    )
    getVersions(data.groupId)
      .then(
        res => {
          if (res.length > 1) {
            setVersionType('preview')
            setVersions(res)
            this.showModal('versionChoiceShowed')
          } else {
            this.handleDifferPreview(data, groupDataTemplate.id, res[0].id)
          }
        },
        err => {
          message.error(err.message)
        }
      )

  }

  editGroupOk = (editGroupName) => {
    //调接口
    const { store: { updateGroup }, data } = this.props

    if ((editGroupName || " ").trim() === "") {
      message.error("家系名称不能为空")
      return
    }
    updateGroup(data.groupId, editGroupName)
      .then(
        res => {
          if (data.groupName !== editGroupName) {
            data.groupName = editGroupName
            data.hasHistory = true
          }

          this.closeModal("showEditModal")
          message.success("编辑报告组成功")
        },
        err => {
          message.error(err)
        }
      )
  }

  checkOperatable = (record) => {
    return record.state === SUCCESS
  }

  showDeleteModal = (record) => {
    if (!this.checkOperatable(record)) {
      return
    }
    this.setState({
      showDeleteModal: true,
      dataSingle: record,
    })
  }

  showDeleteGroupModal = (record) => {
    this.setState({
      showDeleteGroupModal: true,
      dataSingle: record,
    })
  }

  deleteReport = (groupId) => {
    const { store: { deleteReport, recoveryTableData }, data } = this.props
    const { dataSingle } = this.state

    // 准备和运行中的数据无法删除
    if (dataSingle.state === PREPARE_RUN || dataSingle.state === RUNNING
    ) {
      message.error("准备和运行中的数据无法删除")
      return
    }

    deleteReport(groupId, dataSingle.reportId)
      .then(res => {
        const deleteIndex = data.reportList.indexOf(dataSingle)
        recoveryTableData.unshift(dataSingle)
        data.reportList.splice(deleteIndex, 1)
        data.deletedDataCount++

        this.refs.editModal
          && this.refs.editModal.refs.recoveryTable.wrappedInstance.showHistoryReport()

        message.success("报告删除成功")
        this.setState({ showDeleteModal: false })

      }, err => {
        message.error(err.message)
      })
  }

  deleteGroup = () => {
    const { store: { deleteGroup, list }, data, groupIndex } = this.props
    deleteGroup(data.groupId)
      .then(
        res => {
          list.tableData.splice(groupIndex, 1)
          this.closeModal("showEditModal")
          this.closeModal("showDeleteGroupModal")
          message.success("删除报告组及报告成功")
        },
        err => {
          message.error(err.message)
        }
      )
  }

  closeDeleteModal = () => {
    this.setState({ showDeleteModal: false })
  }

  tracerIsEqual = (record) => {
    let isEqual = null
    const udf = undefined
    const d = record.dataTracer ? record.dataTracer.trim() : record.dataTracer
    const t = record.tracer ? record.tracer.trim() : record.tracer
    if (d === t || (d === udf && t === udf) || (d === udf && t === 'NULL') || record.state !== 2) {
      isEqual = true
    } else {
      isEqual = false
    }
    return isEqual
  }

  render() {
    const {
      data,
      store,
      onOpenDetail
    } = this.props
    let {
      shareModalShowed,
      showDeleteModal,
      showDeleteGroupModal,
      dataSingle,
      cancelShareModal,
    } = this.state
    const renderContent = (text, record, index) => {
      const obj = {
        children: text,
        props: {},
      }

      if (record.state === PREPARE_RUN || record.state === RUNNING || record.state === FAIL) {
        obj.props.colSpan = 0
      }
      return obj
    }

    const deleteColumn = {
      title: "操作",
      dataIndex: "oprator",
      width: 50,
      className: "ta-c",
      render: (text, record, index) => {
        const operatable = this.checkOperatable(record)
        let imgClass = cx({
          "cursor-p": true,
          "disable": !operatable
        })
        let deleteIcon = operatable
          ? deleteAbleIcon
          : deleteDisableIcon

        return (
          <Row className="table-oprator ta-c" type="flex" justify="center" align="middle">
            <img
              className={imgClass}
              alt="删除"
              src={deleteIcon}
              onClick={() => this.showDeleteModal(record)} />
          </Row>
        )
      }
    }

    const deleteColumns = [
      {
        width: "12.71%",
        title: "样本名称",
        dataIndex: "sampleName",
        sorter: (a, b) => a.sampleName.localeCompare(b.sampleName),
        render: (text) => {
          return (
            <MaterialTip
              overlayClassName="ellipsis-tip"
              title={text}
            >
              <div className="sample-name ellipsis">{text}</div>
            </MaterialTip>
          )
        }
      }
    ]

    const columns = [{
      width: "10.71%",
      title: "样本名称",
      dataIndex: "sampleName",
      sorter: (a, b) => a.sampleName.localeCompare(b.sampleName),
      render: (text, record, index) => {
        const operatable = this.checkOperatable(record)
        const filenameClass = cx({
          "sample-name blue-text2 ellipsis": true,
          "unread-table-column ": true,
          "unread-message": record.isRead === false,
          "cursor-p": operatable,
          disable: !operatable,
        })
        const { list: { queryMap: { sampleName, keywords } } } = this.props.store
        return (
          <MaterialTip title={text}>
            <div
              className={filenameClass}
              onClick={operatable && (() => onOpenDetail(data, record))}
            >
              <Highlighter
                highlightClassName="lightlight"
                highlightStyle={{ fontWeight: "normal" }}
                searchWords={
                  highlightable(text, sampleName || keywords) ? [text] : []
                }
                textToHighlight={text || ""}
              />
            </div>
          </MaterialTip>
        )
      }
    }]
    if (data.reportList) {  // 新建组传文件且文件正在运行会没有reportList字段从而报错
      const statistical = [
        {
          title: "Total_bases",
          className: "ta-r",
          dataIndex: "totalBases",
          render: (text, record, index) => {
            const stateData = [
              {
                text: "数据准备运行",
                className: "pre-run pgs-state-element"
              },
              {
                text: "数据正在运行",
                className: "running pgs-state-element"
              },
            ]
            switch (record.state) {
              case PREPARE_RUN:
                return {
                  children: (
                    <Row type="flex" justify="center" align="middle">
                      <div className={stateData[0].className}>
                        <Icon type="hourglass" />
                        {stateData[0].text}
                      </div>
                    </Row>
                  ),
                  props: {
                    colSpan: 9
                  }
                }
              case RUNNING:
                return {
                  children: (
                    <Row type="flex" justify="center" align="middle">
                      <div className={stateData[1].className}>
                        <Icon type="clock-circle-o" />
                        {stateData[1].text}
                      </div>
                    </Row>
                  ),
                  props: {
                    colSpan: 9
                  }
                }
              case FAIL:
                return {
                  children: (
                    <Row type="flex" justify="center">
                      <div className="pgs-state-element run-failed">
                        <Icon type="close-circle" />
                          数据运行失败，
                        <div className="failed-button" onClick={() => this.copyText(record.reportId)}>
                          点击复制错误信息
                        </div>
                        发送给管理员，将尽快为您解决问题。
                      </div>
                    </Row>
                  ),
                  props: {
                    colSpan: 9
                  }
                }
              case SUCCESS:
                return (<div>{text}</div>)
              default:
                return (<div>{text}</div>)
            }
          }
        }, {
          title: "Dup_bases",
          className: "ta-r",
          dataIndex: "dupBases",
          render: renderContent
        }, {
          title: "Mapped_bases",
          className: "ta-r",
          dataIndex: "mappedBases",
          render: renderContent
        }, {
          title: "Target_bases",
          className: "ta-r",
          dataIndex: "targetBases",
          render: renderContent
        }, {
          title: "Target_mean_depth",
          className: "ta-r",
          dataIndex: "targetMeanDepth",
          render: renderContent
        }, {
          title: "Target_cov_1x",
          className: "ta-r",
          dataIndex: "targetCov1x",
          render: renderContent
        }, {
          title: "Target_cov_10x",
          className: "ta-r",
          dataIndex: "targetCov10x",
          render: renderContent
        },{
          title: "Target_cov_20x",
          className: "ta-r",
          dataIndex: "targetCov20x",
          render: renderContent
        }, {
          title: "Target_cov_30x",
          className: "ta-r",
          dataIndex: "targetCov30x",
          render: renderContent
        }
      ]
      columns.push(...statistical, deleteColumn)
      deleteColumns.push(...statistical)
    }
    return (
      <Row type="flex" className="report-card">
        <div className="card-left">
          <div className="content">
            <div className="info">
              <Row type="flex" justify="start" align="middle" className="info-group">
                <label>数据类型：</label><div className="text-content">{data.appGroupName.toUpperCase()}</div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>批次号：</label>
                <div className="text-content">
                  {data.groupName}
                </div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>样本数量：</label><div className="text-content">{data.totalDataCount}</div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>已删除样本数量：</label><div className="deleted-count">{data.deletedDataCount}</div>
              </Row>
              <Row type="flex" justify="start" className="info-group">
                <label>创建时间：</label><div className="text-content">{data.createTime}</div>
              </Row>
            </div>
            {this.renderGroupButtons()}
          </div>
        </div>
        <Table
          columns={columns}
          className="report-card-content"
          rowKey={record => record.reportId}
          dataSource={data.reportList.slice()}
          pagination={false}
        />

        {/* 分享modal */}

        {shareModalShowed &&
          <ShareModal
            visible
            store={store}
            action={this.shareGroup}
            onCancel={this.closeModal}
            data={data}
          />
        }

        {/* 下载modal */}

        <DownloadingModal
          visible={this.state.downLoadModal}
          text={this.state.downLoadText}
        />

        {/* 编辑modal */}
        {this.state.showEditModal &&
          <EditModal
            ref="editModal"
            store={store}
            data={data}
            editGroupOk={this.editGroupOk}
            onClose={() => this.closeModal("showEditModal")}
            checkOperatable={this.checkOperatable}
            showDeleteModal={this.showDeleteModal}
            showDeleteGroupModal={this.showDeleteGroupModal}
            deleteColumns={deleteColumns}
          />
        }

        {/* 删除单条modal */}
        {showDeleteModal &&
          <Modal
            className="pgx-modal reportcard-delete-modal"
            title={(
              <Row className="pgx-modal-title" type="flex" justify="center" align="middle" >
                <img src={titleIcon} alt="" />
                <div className="content">报告删除确认</div>
                <img src={titleIcon} alt="" />
              </Row>
            )}
            visible
            footer={(
              <Row
                type="flex"
                justify="center"
                align="middle"
                onClick={
                  () => this.deleteReport(data.groupId)
                }
              >
                <button className="pgx-modal-delete-btn" type="primary">删除</button>
              </Row>
            )}
          >
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={this.closeDeleteModal}
            />
            <Row type="flex" justify="center" align="middle">
              {dataSingle.filename}
            </Row>
            <Row className="warning-line1" type="flex" justify="center" align="middle" gutter={8}>
              <img src={deleteWarningIcon} alt="" />
              <div>您确定要删除本条报告吗？</div>
            </Row>
          </Modal>
        }

        {/* 删除组modal */}
        {showDeleteGroupModal &&
          <Modal
            className="pgx-modal reportcard-delete-modal"
            title={(
              <Row className="pgx-modal-title" type="flex" justify="center" align="middle" >
                <img src={titleIcon} alt="" />
                <div className="content">报告组删除确认</div>
                <img src={titleIcon} alt="" />
              </Row>
            )}
            visible
            footer={(
              <Row
                type="flex"
                justify="center"
                align="middle"
                onClick={
                  () => this.deleteGroup()
                }
              >
                <button className="pgx-modal-delete-btn" type="primary">删除</button>
              </Row>
            )}
          >
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={() => this.closeModal("showDeleteGroupModal")}
            />
            {/* <Row type="flex" justify="center" align="middle">
              {dataSingle.filename}
            </Row> */}
            <Row className="warning-line1" type="flex" justify="center" align="middle" gutter={8}>
              <img src={deleteWarningIcon} alt="" />
              <div>您确定要删除本组报告吗？</div>
            </Row>
          </Modal>
        }

        {/* 取消分享modal */}

        {cancelShareModal &&
          <MaterialModal
            className="pgs-datamanage-delete-modal"
            title="取消分享确认"
            visible={true}
            action={() => {
              store.cancelShare(data.groupId, data.ownerId, 'fromId')
                .then(
                  res => { this.closeModal("cancelShareModal") },
                )
            }}
            buttonText="确认"
            buttonType="danger"
          >
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={() => this.closeModal("cancelShareModal")}
            />
            <Row type="flex" justify="center" align="middle">
              {data.groupName}
            </Row>
            <Row className="warning-line1" type="flex" justify="center" align="middle" gutter={8}>
              <img src={deleteWarningIcon} alt="" />
              <div>您确认取消 {data.ownerName} 共享给您的数据吗？</div>
            </Row>
          </MaterialModal>
        }
      </Row>
    )
  }
}

@observer
class EditModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dataSingle: {},
      groupName: props.data.groupName
    }

    this.deleteColumns = [...props.deleteColumns, {
      title: "操作",
      dataIndex: "oprator",
      width: 50,
      className: "ta-c",
      render: (text, record, index) => {
        const operatable = props.checkOperatable(record)
        let imgClass = cx({
          "cursor-p": true,
          "disable": !operatable
        })
        let deleteIcon = operatable
          ? deleteAbleIcon
          : deleteDisableIcon

        return (
          <Row className="table-oprator ta-c" type="flex" justify="center" align="middle">
            <img
              className={imgClass}
              alt="删除"
              src={deleteIcon}
              onClick={() => props.showDeleteModal(record)} />
          </Row>
        )
      }
    }]

    this.recoveryColumns = [...props.deleteColumns,
    {
      title: "操作",
      dataIndex: "oprator",
      width: 50,
      className: "ta-c",
      render: (text, record, index) => {
        return (
          <Row className="table-oprator ta-c" type="flex" justify="center" align="middle">
            <img alt="恢复" src={recoveryIcon} onClick={() => this.recoveryReport(record, index)} />
          </Row>
        )
      }
    }
    ]
  }

  recoveryReport = (record, recoveryIndex) => {
    const { store: { recoveryReport, recoveryTableData }, data } = this.props

    //调接口
    recoveryReport(data.groupId, record.reportId)
      .then(
        res => {
          recoveryTableData.splice(recoveryIndex, 1)
          data.reportList.unshift(record)
          data.deletedDataCount--

          message.success("报告恢复成功")
        },
        err => {
          message.error(err.message)
        }
      )
  }

  onGroupNameChange = (e) => {
    this.setState({
      groupName: e.target.value
    })
  }

  render() {
    const { data, onClose, editGroupOk, store, showDeleteGroupModal } = this.props
    const { groupName } = this.state

    return (
      <MaterialModal
        className="pgs-reportcard-edit-modal"
        title="编辑报告组"
        visible
        width={1160}
        footer={(
          <Row type="flex" justify="center" align="middle">
            <button
              className="delete-group-btn"
              onClick={showDeleteGroupModal}
            >
              删除报告组及报告
            </button>
          </Row>
        )}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onClose}
        />
        <Row type='flex' justify='start' align='middle' className='subtitle'>
          <i></i>
          <MaterialFormItem
            labelWidth={47}
            labelText="家系名称"
            className="group-name"
          >
            <Row type="flex" justify="start" align='middle'>
              <Input
                onChange={this.onGroupNameChange}
                name="groupName" type="text"
                className="name-input"
                defaultValue={data.groupName}
                placeholder="请输入家系名称"
              />
            </Row>
          </MaterialFormItem>
          <button className="primary-btn confirm" onClick={() => editGroupOk(groupName)}>确认修改家系</button>
        </Row>
        <Table
          columns={this.deleteColumns}
          rowKey={record => record.reportId + "delete"}
          scroll={{ y: 235 }}
          className="delete-table"
          dataSource={data.reportList.slice()} pagination={false}
        />
        <RecoveryTable
          store={store}
          ref="recoveryTable"
          recoveryColumns={this.recoveryColumns}
        />

        {/* 删除确认modal */}
      </MaterialModal>
    )
  }
}

@inject("entrance") @observer
class RecoveryTable extends Component {
  state = {
    isFirstRender: true,
    showHistoryReport: false
  }

  toggleHistoryReport = () => {
    this.setState({
      showHistoryReport: !this.state.showHistoryReport,
      isFirstRender: false
    })
  }

  showHistoryReport = () => {
    this.setState({
      showHistoryReport: true,
      isFirstRender: false
    })
  }

  /**
   * 需求描述：
   *    第一次进来时、数据渲染到后且 showHistoryReport false 时展示 [], 其他条件均展示真实数据
   */
  render() {
    const { showHistoryReport, isFirstRender } = this.state
    const { recoveryColumns, store: { recoveryTableData } } = this.props

    const recoveryTableClass = cx({
      "recovery-table": true,
      "close": !showHistoryReport,
    })
    const extendBtnClass = cx({
      "close-btn": showHistoryReport,
      "extend-btn": !showHistoryReport
    })

    return (
      <div>
        <Row type='flex' justify='start' align='middle' className='subtitle history'>
          <i></i>
          <b>已删除报告（{recoveryTableData.length}条）</b>
          <div className="line"></div>
          <button onClick={this.toggleHistoryReport} className={extendBtnClass}>
            {showHistoryReport ? "收起" : "展开"}
          </button>
        </Row>
        <Table
          columns={recoveryColumns}
          rowKey={record => record.reportId + "recovery"}
          scroll={{ y: 141 }}
          className={recoveryTableClass}
          dataSource={isFirstRender ? [] : recoveryTableData.slice()} pagination={false} />
      </div>
    )
  }
}

export default withRouter(ReportCard)



// WEBPACK FOOTER //
// ./src/app/components/normal/ecs/ReportCard/index.js